export const FINNISH_TRANSLATIONS = {
  hellovue: {
    frontpage: 'Etusivu',
    site: {
      name: 'Liferay Hello Vue'
    },
    dropdown: {
      select_language: 'Valitse kieli',
      change_type: 'Vaihda rakennustyyppi'
    },
    sidenav: {
      close: 'Sulje valikko',
      change_view: 'Vaihda näkymä',
      street_view: 'Katunäkymä',
      cut_view: 'Poikkileikkausnäkymä'
    },
    view: {
      street_view: 'katunakyma',
      cross_section_view: 'poikkileikkausnakyma'
    },
    pov_of_educational_buildings: "Läpileikkaus oppimisen rakennuksiin",
    buildings: "Rakennukset",
    maincontent: {
      back_to_frontpage: "Takaisin oppimisen rakennuksiin",
      back_to_buildings: "Takaisin rakennuksiin",
      move_to_cross_section_view: "Siirry poikkileikkausnäkymään"
    },
    header:{
      street_view_of_learning_facilities: "Läpileikkaus oppimisen rakennuksiin"
    }
  }
};
